import {
  Button,
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
  MenuItem,
  IconButton,
  CardContent,
  List,
  Divider,
  ListItem,
  Tooltip,
} from "@mui/material";
import { useStyles } from "../../../theme/appStyles";
import React, { useEffect, useMemo, useState } from "react";
import { CircularProgress, Grid, Box, Typography } from "@mui/material";
import {
  useChangeStatusOrderListSentToManagerMutation,
  useAdminSetPriceOrderListMutation,
  useGetOrderListByIdQuery,
  useGetUserInfoOnyQuery,
  useAdminChangeStatusMutation,
  useAdminConformStorePriceQuery,
  useGetStoreQuery,
  useGetProductQuery,
  useGetRestaurantQuery,
} from "../../../Api/attoDeskApi";
import {
  IOrderListPriceEdit,
  IOrderList,
  IUserAdmin,
  IStore,
  IVariantView,
  IStoreItemAdminEdit,
  IRestaurant,
} from "../../../Api/Interface/api.interface";
import { Link, useParams } from "react-router-dom";
import {
  OrderListStatus,
  SizeOfLevelType,
  editPriceOrderListStatus,
} from "../../../Core/Enum/enum";
import TableViewIcon from "@mui/icons-material/TableView";
import LocalPrintshopSharpIcon from "@mui/icons-material/LocalPrintshopSharp";
import dayjs, { Dayjs } from "dayjs";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import { useNavigate } from "react-router-dom";
import { useNotifier } from "../../../Core/Notifier";
import StatusPopup from "../../../Components/Delete/StatusPopup";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useFormik } from "formik";
import NewPopUpProduct from "../../Product/Edit/storepriceOnly";
import { CiEdit } from "react-icons/ci";
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
import useIsMobile from "../../../Core/hook/useIsMobile";
import { useSelector } from "react-redux";
import { RootState } from "../../../Store";
import ReplyIcon from "@mui/icons-material/Reply";

const convertUnit = (unit: number) => {
  switch (unit) {
    case SizeOfLevelType.kg:
      return "kg";
    case SizeOfLevelType.small:
      return "small";
    case SizeOfLevelType.li:
      return "li";
    case SizeOfLevelType.Medium:
      return "Medium";
    case SizeOfLevelType.Bottle:
      return "Bottle";
    case SizeOfLevelType.Each:
      return "Each";
    case SizeOfLevelType.Large:
      return "Large";
    case SizeOfLevelType.case:
      return "Case";
    case SizeOfLevelType.lb:
      return "lb";
    default:
      return "";
  }
};

const convertStatus = (unit: string): string => {
  switch (unit) {
    case "OrderListCreated":
      return "Order List Created";
    case "SentToManager":
      return "Sent To Manager";
    case "ManagerApproved":
      return "Approved";
    case "UpdatedPrice":
      return "Updated Price";
    case "UpdatedStoreOnly":
      return "Updated Store";
    // case "ManagerConfirmed":
    //   return "Confirmed";
    case "Processed":
      return "Processed";
    case "Completed":
      return "Completed";
    case "Rejected":
      return "Rejected";
    default:
      return "";
  }
};

const Index = () => {
  const classes = useStyles();
  const isMobileRes = useIsMobile();
  const { showErrorMessage, showMessage } = useNotifier();
  const { id: orderListHistoryId } = useParams<{ id: string }>();
  const [orderList, setOrderList] = useState<IOrderListPriceEdit[]>([]);
  // const [groupedData, setGroupedData] = useState<
  //   Record<number, IOrderListPriceEdit[]>
  // >({});
  const { companyLogo, logowidthPrint, companyName } = useSelector(
    (state: RootState) => state.company
  );

  const [groupedData, setGroupedData] = useState<
    Record<string, IOrderListPriceEdit[]>
  >({});
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10000);
  const navigate = useNavigate();
  const [coursingToStatus, setCoursingToStatus] = useState<string | undefined>(
    ""
  );
  const [open, setOpen] = useState(false);
  const [openOrderListDate, setOpenOrderListDate] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState<String | undefined>(
    undefined
  );
  const [selectedProductData, setSelectedProductData] = useState<
    IVariantView | undefined
  >(undefined);
  const [openDialog, setOpenDialog] = useState(false);

  const {
    data: orderListData,
    isLoading: orderListIsLoading,
    isError: orderListIsError,
    refetch,
  } = useAdminConformStorePriceQuery({
    id: String(orderListHistoryId),
  });

  const {
    data: OrderListDate,
    isLoading: OrderListDateIsLoading,
    isError: OrderListDateIsError,
  } = useGetOrderListByIdQuery({
    searchText: "",
    id: String(orderListHistoryId),
  });

  // const {
  //   data: orderListData,
  //   isLoading: orderListIsLoading,
  //   isError: orderListIsError,
  //   refetch: orderListRefetch,
  // } = useGetAllGetOrderListHistoryQuery({
  //   orderId: String(orderListHistoryId),
  //   searchText: "",
  // });
  const { data: userData, isLoading: userIsLoading } = useGetUserInfoOnyQuery({
    searchText: "",
  });

  const { data: storeData, isLoading: storeIsLoading } = useGetStoreQuery({
    searchText: "",
    id: "",
  });

  const [newStatus, { isLoading }] = useAdminChangeStatusMutation();
  const [newOrderListPrice, { isLoading: orderListPriceIsLoading }] =
    useAdminSetPriceOrderListMutation();

  const { data: restaurantData, isLoading: restauramtIsLoading } =
    useGetRestaurantQuery({
      searchText: "",
      id: "",
    });

  const {
    data: OrderlistEditProductIdDate,
    isLoading: OrderlistEditProductIdIsLoading,
    isError: OrderlistEditProductIdIsErrr,
  } = useGetProductQuery(
    {
      searchText: "",
      id: String(selectedProduct),
      variantBrandId: null,
      categoryId: null,
      variantTagId: null,
      productViewOnline: null,
      createdDateStart: null,
      createdDateEnd: null,
      createdDate: null,
      mainItemId: null,
    },
    {
      skip: !selectedProduct,
    }
  );

  const dataProduct = useMemo(() => {
    if (
      OrderlistEditProductIdDate &&
      Array.isArray(OrderlistEditProductIdDate.data) &&
      OrderlistEditProductIdDate.data.length > 0
    ) {
      return OrderlistEditProductIdDate.data[0] as IVariantView;
    }
    return undefined;
  }, [OrderlistEditProductIdDate]);

  useEffect(() => {
    if (dataProduct) {
      setSelectedProductData(dataProduct);
    }
  }, [dataProduct]);

  const orderListHisrotyRecord = useMemo(() => {
    return orderListData?.data as IOrderListPriceEdit[];
  }, [orderListData?.data]);

  const orderListDate = useMemo(() => {
    return OrderListDate?.data as IOrderList[];
  }, [OrderListDate?.data]);

  const userList = useMemo(() => {
    return userData?.data as IUserAdmin[];
  }, [userData?.data]);

  const restaurantList = useMemo(() => {
    return restaurantData?.data as IRestaurant[];
  }, [restaurantData?.data]);

  const getAllStoreList = useMemo(() => {
    return storeData?.data as IStore[];
  }, [storeData?.data]);

  const userMap = useMemo(() => {
    const map = new Map();
    userList?.forEach((category) => {
      map.set(category.id, `${category.user_role_name}`);
    });
    return map;
  }, [userList]);

  const userMap2 = useMemo(() => {
    const map = new Map();
    userList?.forEach((category) => {
      map.set(category.id, `${category.user_role_name}`);
    });
    return map;
  }, [userList]);

  const getStoreMap = useMemo(() => {
    const map = new Map();
    getAllStoreList?.forEach((category) => {
      map.set(category.id, category.storeName);
    });
    return map;
  }, [getAllStoreList]);

  const restaurantMap = useMemo(() => {
    const map = new Map();
    restaurantList?.forEach((category) => {
      map.set(category.id, category.restaurantsName);
    });
    return map;
  }, [restaurantList]);

  const ReDateId =
    orderListDate?.length > 0 ? orderListDate[0].orderListId : null;
  const createBy =
    orderListDate?.length > 0 ? orderListDate[0].created_by : null;
  const createAt =
    orderListDate?.length > 0 ? orderListDate[0].created_at : null;
  const orderListStatus =
    orderListDate?.length > 0 ? orderListDate[0].orderListStatus : null;
  const updatedBy =
    orderListDate?.length > 0 ? orderListDate[0].updated_by : null;
  const updatedAt =
    orderListDate?.length > 0 ? orderListDate[0].updated_at : null;
  const branchId =
    orderListDate?.length > 0 ? orderListDate[0].restaurantsId : null;
  // useEffect(() => {
  //   // Grouping products by store ID using minimumpriceDetails store ID
  //   const grouped: Record<number, IOrderListPriceEdit[]> = {};
  //   orderList.forEach((order) => {
  //     const storeId = order.minimumpriceDetails.storeId;
  //     if (!grouped[storeId]) {
  //       grouped[storeId] = [];
  //     }
  //     grouped[storeId].push(order);
  //   });
  //   setGroupedData(grouped);
  // }, [orderList]);

  useEffect(() => {
    // Grouping products by store ID using minimumpriceDetails store ID, handling null values
    const grouped: Record<string, IOrderListPriceEdit[]> = {};
    orderList.forEach((order) => {
      let storeId: string | number = "null";

      if (order.minimumpriceDetails) {
        // If minimumpriceDetails is available, use its storeId
        storeId = order.minimumpriceDetails.storeId;
      } else {
        // Find the lowest price from storePriceResults if minimumpriceDetails is null
        const minPriceStore = order.storePriceResults.reduce((min, store) => {
          return store.price !== null &&
            (min === null || store.price < min.price)
            ? store
            : min;
        }, null as IStoreItemAdminEdit | null);

        if (minPriceStore) {
          storeId = minPriceStore.storeId;
        }
      }

      if (!grouped[storeId]) {
        grouped[storeId] = [];
      }
      grouped[storeId].push(order);
    });
    setGroupedData(grouped);
  }, [orderList]);

  const handleOpenDialog = (productId: String) => {
    setSelectedProduct(productId);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setSelectedProduct(undefined);
    setOpenDialog(false);
    setSelectedProductData(undefined);
    refetch();
  };

  const handleExportGroupedExcel = () => {
    const wb = XLSX.utils.book_new();

    Object.entries(groupedData).forEach(([storeId, orders]) => {
      const storeName =
        storeId === undefined || storeId === null
          ? "Update Items Price to Supplier"
          : getStoreMap.get(Number(storeId)) || "Supplier Not Found";

      const sheetData = [
        ["Items", "Price", "Qty"],
        ...orders.map((order) => [
          order.variantName || "",
          order.minimumpriceDetails?.price
            ? `$${order.minimumpriceDetails.price}`
            : "N/A",
          `${order.productTotalUnit} ${convertUnit(order.variantUnit)}`,
        ]),
      ];

      const ws = XLSX.utils.aoa_to_sheet(sheetData);
      XLSX.utils.book_append_sheet(wb, ws, storeName.slice(0, 31));
    });

    const today = dayjs();
    const formattedDate = today.format("MMM, DD YYYY (dddd)");
    const filename = `Grouped_Store_Orders_${formattedDate}`;
    XLSX.writeFile(wb, `${filename}.xlsx`);
  };

  const handleExportGroupedPDF = () => {
    const doc = new jsPDF("l", "mm", "a4");
    const imageUrl = companyLogo;
    const pageWidth = doc.internal.pageSize.width;
    const imgWidth = logowidthPrint;
    const imgHeight = 10;
    // const imgX = (pageWidth - imgWidth) / 2;
    const imgY = 10;
    const imgX = 15;

    const img = new Image();
    img.src = imageUrl;

    doc.addImage(img, "PNG", imgX, imgY, imgWidth, imgHeight);

    const rightTextX = pageWidth - 15;
    let rightTextY = 12;

    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");

    doc.text(`${ReDateId}`, rightTextX, rightTextY, { align: "right" });
    rightTextY += 4;

    // doc.text(`${convertStatus(orderListStatus || "")}`, rightTextX, rightTextY, { align: "right" });
    // rightTextY += 4;

    doc.text(`${restaurantMap.get(branchId) || ""}`, rightTextX, rightTextY, {
      align: "right",
    });

    let currentY = 35;

    Object.entries(groupedData).forEach(([storeId, orders], idx) => {
      const storeName =
        storeId === undefined || storeId === null
          ? "Update Items Price to Supplier"
          : getStoreMap.get(Number(storeId)) || "Supplier Not Found";

      const tableData = orders.map((order) => [
        order.variantName || "",
        order.minimumpriceDetails?.price
          ? `$${order.minimumpriceDetails.price}`
          : "N/A",
        `${order.productTotalUnit} ${convertUnit(order.variantUnit)}`,
      ]);

      // Store name left-aligned heading
      doc.setFontSize(12);
      doc.setFont("helvetica", "normal");
      doc.text(storeName, 12, currentY);

      currentY += 5;

      (doc as any).autoTable({
        head: [["Items", "Price", "Qty"]],
        body: tableData,
        startY: currentY,
        theme: "grid",
        styles: { fontSize: 8 },
        headStyles: { fillColor: [200, 200, 200] },
        alternateRowStyles: { fillColor: [245, 245, 245] },
        // margin: { top: 10 },
        didDrawPage: (data: any) => {
          currentY = data.cursor.y + 10;
        },
      });

      if (idx !== Object.entries(groupedData).length - 1) {
        currentY += 5; // Space between groups
      }
    });
    const today = dayjs();
    const formattedDate = today.format("MMM, DD YYYY (dddd)");
    const filename = `Grouped_Store_Orders_${formattedDate}.pdf`;
    doc.save(filename);
  };

  useEffect(() => {
    if (orderListHisrotyRecord) {
      setOrderList(orderListHisrotyRecord);
    }
  }, [orderListHisrotyRecord]);

  const handleOpenStatusPopup = () => {
    setCoursingToStatus(String(orderListHistoryId));
    setOpen(true);
  };

  const handleCloseStatusPopup = () => {
    setCoursingToStatus(undefined);
    setOpen(false);
  };

  const handleOpenDialogGenerate = () => {
    setOpenOrderListDate(true);
  };

  const handleCloseDialogGenerate = () => {
    setOpenOrderListDate(false);
  };

  // const handleStoreSelection = (productId: string, storeId: number) => {
  //   setOrderList((prevOrderList) =>
  //     prevOrderList.map((item) =>
  //       Number(item.productId) === Number(productId)
  //         ? {
  //             ...item,
  //             storePriceResults: item.storePriceResults.map((store) => ({
  //               ...store,
  //               isminimumprice: store.storeId === storeId,
  //             })),
  //           }
  //         : item
  //     )
  //   );
  // };

  const handleStoreSelection = (productId: string, storeId: number) => {
    setOrderList((prevOrderList) =>
      prevOrderList.map((item) =>
        Number(item.productId) === Number(productId)
          ? {
              ...item,
              storePriceResults: item.storePriceResults.map((store) => ({
                ...store,
                isminimumprice: store.storeId === storeId,
              })),
              minimumpriceDetails:
                item.storePriceResults.find(
                  (store) => store.storeId === storeId
                ) || item.minimumpriceDetails,
            }
          : item
      )
    );
  };

  const formik = useFormik({
    initialValues: {
      id: "",
      status: "SentTofManager",
    },
    onSubmit: async (values, { resetForm }) => {
      try {
        const temData = {
          id: String(orderListHistoryId),
          status: values.status,
        };

        const addCompanyResponse = await newStatus(temData).unwrap();
        if (!addCompanyResponse.status) {
          showErrorMessage(addCompanyResponse.message);
        } else {
          showMessage(addCompanyResponse.message);
          resetForm();
          setOpenOrderListDate(false);
          navigate(`/order/list/view/${orderListHistoryId}`);
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  const confirmFormik = useFormik({
    initialValues: {
      orderListId: "",
      orderListHistory: [],
    },
    onSubmit: async (values, { resetForm }) => {
      try {
        const temData = {
          orderListId: String(orderListHistoryId),
          orderListHistory: orderList,
        };

        const addCompanyResponse = await newOrderListPrice(temData).unwrap();
        if (!addCompanyResponse.status) {
          showErrorMessage(addCompanyResponse.message);
        } else {
          showMessage(addCompanyResponse.message);
          resetForm();
          setOpenOrderListDate(false);
          navigate(`/order/list/set/price/list/${orderListHistoryId}`);
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  const [changeStatus] = useChangeStatusOrderListSentToManagerMutation();

  const handleChangeStatus = async (id: string) => {
    try {
      const response = await changeStatus(id).unwrap();
      if (response.status) {
        showMessage(response.message);
        setOpen(false);
        navigate(`/order/list/view/${response.id}`);
      } else {
        showErrorMessage(response.message);
      }
    } catch (error) {
      showErrorMessage("Failed to change status");
    }
  };

  const formValid = useMemo(() => {
    return formik.values.status !== "" && formik.values.status !== undefined;
  }, [formik]);

  // const confirmFormikValid = useMemo(() => {
  //   return orderList.length > 0;
  // }, [orderList]);

  const confirmFormikValid = useMemo(() => {
    // Check if there is any order with a null storeId
    return orderList.every((order) => order.minimumpriceDetails !== null);
  }, [orderList]);

  if (
    orderListIsLoading ||
    OrderListDateIsLoading ||
    storeIsLoading ||
    restauramtIsLoading
  ) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Grid container spacing={3}>
      <Grid item lg={8} md={6} sm={12} xs={12}>
        <Card
          className={
            isMobileRes
              ? classes.orderListLeftCardViewNotHight
              : classes.orderListLeftCardView
          }
          sx={{ height: "100%" }}
        >
          <Grid
            container
            justifyContent={"space-between"}
            spacing={5}
            sx={{ padding: 2 }}
            className={classes.orderListLeftHeader}
            mb={7}
          >
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Grid
                container
                spacing={1}
                justifyContent="flex-end"
                sx={{ display: "flex" }}
              >
                <Grid item>
                  <Button
                    startIcon={<TableViewIcon />}
                    className={classes.ordeListButton}
                    onClick={handleExportGroupedExcel}
                  >
                    Excel
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    startIcon={<LocalPrintshopSharpIcon />}
                    className={classes.ordeListButton}
                    onClick={handleExportGroupedPDF}
                  >
                    pdf
                  </Button>
                </Grid>
                {/* <Grid item>
                  <Button
                    startIcon={<CheckCircleOutlineIcon />}
                    className={classes.ordeListConfirmButton}
                    onClick={() => {
                      if (orderListStatus === "OrderListCreated") {
                        handleOpenStatusPopup();
                      } else {
                        handleOpenDialogGenerate();
                      }
                    }}
                  >
                    Status
                  </Button>
                </Grid> */}
                <Grid item>
                  <Link
                    to={`/order/list/view/${orderListHistoryId}`}
                    className={classes.iconLinkPropNormal}
                  >
                    <Button
                      startIcon={<ReplyIcon />}
                      className={classes.ordeListConfirmButton}
                      onClick={() =>
                        navigate(`/order/list/view/${orderListHistoryId}`)
                      }
                    >
                      Back
                    </Button>
                  </Link>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid container spacing={2} p={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container justifyContent={"space-between"} spacing={2}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid container justifyContent={"space-between"} spacing={2}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <TableContainer>
                        <Table className={classes.table}>
                          <TableHead className={classes.tableHeaderRow}>
                            <TableRow>
                              <TableCell
                                className={classes.oLTablHeader}
                                sx={{ minWidth: "150px" }}
                              >
                                <strong>Items</strong>
                              </TableCell>
                              <TableCell
                                className={classes.oLTablHeader}
                                sx={{ minWidth: "300px" }}
                              >
                                <strong>Select Supplier</strong>
                              </TableCell>
                              <TableCell
                                className={classes.oLTablHeader}
                                sx={{ textAlign: "center", minWidth: 400 }}
                              >
                                <strong>Confirm Supplier</strong>
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {orderListIsLoading ? (
                              <TableRow>
                                <TableCell colSpan={20} align="center">
                                  <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    height="10vh"
                                  >
                                    <CircularProgress />
                                  </Box>
                                </TableCell>
                              </TableRow>
                            ) : orderListIsError ? (
                              <TableRow>
                                <TableCell colSpan={20} align="center">
                                  <Typography className={classes.leftORTypo}>
                                    Some thing went to wrong
                                  </Typography>
                                </TableCell>
                              </TableRow>
                            ) : orderList.length === 0 ? (
                              <TableRow>
                                <TableCell colSpan={20} align="center">
                                  <Typography className={classes.leftORTypo}>
                                    No data available
                                  </Typography>
                                </TableCell>
                              </TableRow>
                            ) : (
                              orderList.map(
                                (row: IOrderListPriceEdit, index) => {
                                  const storeMiniName =
                                    getStoreMap.get(
                                      row?.minimumpriceDetails?.storeId
                                    ) || "";
                                  const displayNameTooLongMini =
                                    storeMiniName.length > 15;
                                  return (
                                    <TableRow
                                      key={index}
                                      className={classes.tableRowHover}
                                    >
                                      <TableCell
                                        scope="row"
                                        className={classes.tablCell}
                                      >
                                        <Link
                                          to={`/variant/view/${row.productId}`}
                                          className={classes.iconLinkPropNormal}
                                        >
                                          <Typography
                                            className={classes.leftORTypo}
                                            sx={{
                                              cursor: "pointer",
                                            }}
                                          >
                                            {row.variantName}
                                          </Typography>
                                        </Link>
                                      </TableCell>
                                      <TableCell
                                        scope="row"
                                        className={classes.tablCell}
                                      >
                                        {row.storePriceResults &&
                                        row.storePriceResults.length > 0 ? (
                                          <Box
                                            sx={{
                                              display: "flex",
                                              flexWrap: "wrap",
                                              gap: "10px",
                                              alignItems: "center",
                                            }}
                                          >
                                            {row.storePriceResults.map(
                                              (s, i) => {
                                                const storeName =
                                                  getStoreMap.get(s.storeId) ||
                                                  "";
                                                const displayNameTooLong =
                                                  storeName.length > 15;
                                                return (
                                                  <Box
                                                    key={i}
                                                    sx={{
                                                      padding: "2px 4px",
                                                      borderRadius: "4px",
                                                      display: "inline-flex",
                                                      alignItems: "center",
                                                      backgroundColor:
                                                        s.isminimumprice
                                                          ? "#DFF6DD"
                                                          : "#FFEB3B",
                                                      color: s.isminimumprice
                                                        ? "#166534"
                                                        : "#747474",
                                                      // border: s.isminimumprice
                                                      //   ? "2px solid #22C55E"
                                                      //   : "2px solid #F59E0B",
                                                      // fontWeight: "bold",
                                                      cursor: "pointer",
                                                      transition:
                                                        "0.3s ease-in-out",
                                                      boxShadow:
                                                        "rgba(0, 0, 0, 0.1) 0px 2px 5px",
                                                      minWidth: "100px",
                                                      textAlign: "center",
                                                      "&:hover": {
                                                        transform:
                                                          "scale(1.05)",
                                                      },
                                                    }}
                                                    onClick={() => {
                                                      if (s.price > 0) {
                                                        handleStoreSelection(
                                                          row.productId,
                                                          s.storeId
                                                        );
                                                      } else {
                                                        handleOpenDialog(
                                                          row.productId
                                                        );
                                                      }
                                                    }}
                                                    onDoubleClick={() =>
                                                      handleOpenDialog(
                                                        row.productId
                                                      )
                                                    }
                                                  >
                                                    {/* <Typography variant="body2">
                                                <strong>
                                                  {getStoreMap.get(s.storeId)}{" "}
                                                </strong>
                                                |{" "}
                                                {s.price
                                                  ? `$${s.price}`
                                                  : "N/A"}
                                              </Typography> */}

                                                    {displayNameTooLong ? (
                                                      <Tooltip
                                                        title={
                                                          <>
                                                            <Typography variant="body2">
                                                              <strong>
                                                                {storeName}
                                                              </strong>
                                                            </Typography>
                                                          </>
                                                        }
                                                        sx={{
                                                          fontSize: "14px",
                                                        }}
                                                      >
                                                        <Typography variant="body2">
                                                          {/* <strong> */}
                                                          {`${storeName.slice(
                                                            0,
                                                            15
                                                          )}...`}{" "}
                                                          {/* </strong> */}|{" "}
                                                          {s.price
                                                            ? `$${s.price}`
                                                            : "N/A"}
                                                        </Typography>
                                                      </Tooltip>
                                                    ) : (
                                                      <Typography variant="body2">
                                                        {/* <strong> */}
                                                        {storeName}{" "}
                                                        {/* </strong> */}|{" "}
                                                        {s.price
                                                          ? `$${s.price}`
                                                          : "N/A"}
                                                      </Typography>
                                                    )}
                                                  </Box>
                                                );
                                              }
                                            )}
                                          </Box>
                                        ) : (
                                          <Box
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                            }}
                                          >
                                            <Typography
                                              variant="body2"
                                              sx={{ color: "#888" }}
                                            >
                                              No store prices available
                                            </Typography>
                                            <IconButton
                                              sx={{ marginLeft: "8px" }}
                                              onClick={() =>
                                                handleOpenDialog(row.productId)
                                              }
                                            >
                                              <CiEdit
                                                style={{ color: "#F59E0B" }}
                                              />
                                            </IconButton>
                                          </Box>
                                        )}
                                      </TableCell>
                                      <TableCell
                                        scope="row"
                                        className={classes.tablCell}
                                        sx={{
                                          textAlign: "center",
                                          minWidth: 400,
                                        }}
                                      >
                                        {row.minimumpriceDetails ? (
                                          <Box
                                            sx={{
                                              display: "flex",
                                              flexDirection: "column",
                                              // alignItems: "flex-start",
                                              padding: "12px",
                                              borderRadius: "10px",
                                              border: "0.5px solid #ffffff",
                                              transition: "0.3s ease-in-out",
                                              "&:hover": {
                                                backgroundColor: "#ffffff",
                                                borderRadius: "10px",
                                                border: "0.5px solid #ffffff",
                                                boxShadow:
                                                  "0 4px 12px rgba(0, 0, 0, 0.15)",
                                              },
                                            }}
                                          >
                                            <div
                                              style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                marginBottom: "8px",
                                              }}
                                            >
                                              {displayNameTooLongMini ? (
                                                <Tooltip
                                                  title={
                                                    <>
                                                      <Typography variant="body2">
                                                        <strong>
                                                          {storeMiniName}
                                                        </strong>
                                                      </Typography>
                                                    </>
                                                  }
                                                  sx={{ fontSize: "14px" }}
                                                >
                                                  <Typography
                                                    className={
                                                      classes.productCardTypograpy
                                                    }
                                                    sx={{
                                                      fontWeight: "bold",
                                                      "&:hover": {
                                                        fontWeight: "bold",
                                                        color: "#1a202c",
                                                      },
                                                    }}
                                                  >
                                                    {`${storeMiniName.slice(
                                                      0,
                                                      15
                                                    )}...`}
                                                  </Typography>
                                                </Tooltip>
                                              ) : (
                                                <Typography
                                                  className={
                                                    classes.productCardTypograpy
                                                  }
                                                  sx={{
                                                    fontWeight: "bold",
                                                    "&:hover": {
                                                      fontWeight: "bold",
                                                      color: "#1a202c",
                                                    },
                                                  }}
                                                >
                                                  {storeMiniName}
                                                </Typography>
                                              )}

                                              <Typography
                                                // variant="h6"
                                                style={{
                                                  color:
                                                    row.minimumpriceDetails
                                                      .price > 0
                                                      ? "#28a745"
                                                      : "#e53e3e",
                                                  fontWeight: "bold",
                                                }}
                                              >
                                                {row.minimumpriceDetails.price
                                                  ? `$${row.minimumpriceDetails.price}`
                                                  : "N/A"}
                                              </Typography>

                                              <Typography
                                                variant="body2"
                                                className={
                                                  classes.productCardTypograpy
                                                }
                                                sx={{
                                                  fontWeight: "bold",
                                                }}
                                              >
                                                {row.productTotalUnit}{" "}
                                                {convertUnit(row.variantUnit)}
                                              </Typography>
                                            </div>

                                            {row.minimumpriceDetails.price >
                                              0 && (
                                              <div
                                                style={{
                                                  display: "flex",
                                                  justifyContent:
                                                    "space-between",
                                                  alignItems: "center",
                                                  backgroundColor: "#f0f4f8",
                                                  padding: "8px",
                                                  borderRadius: "8px",
                                                  marginTop: "8px",
                                                  border: "1px solid #ccc",
                                                }}
                                              >
                                                <Typography
                                                  variant="body1"
                                                  style={{
                                                    fontWeight: "bold",
                                                    color: "#333",
                                                  }}
                                                >
                                                  Total Price :
                                                </Typography>

                                                <Typography
                                                  variant="body1"
                                                  style={{
                                                    fontWeight: "bold",
                                                    color: "#007bff",
                                                  }}
                                                >
                                                  $
                                                  {(
                                                    row.minimumpriceDetails
                                                      .price *
                                                    row.productTotalUnit
                                                  ).toFixed(2)}
                                                </Typography>
                                              </div>
                                            )}
                                          </Box>
                                        ) : (
                                          <Typography
                                            variant="body2"
                                            sx={{ color: "#888" }}
                                          ></Typography>
                                        )}
                                      </TableCell>

                                      {/* <TableCell
                                  scope="row"
                                  className={classes.tablCell}
                                >
                                  {row.minimumpriceDetails ? (
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        padding: "12px",
                                        backgroundColor: "#f9f9f9",
                                        borderRadius: "8px",
                                        boxShadow:
                                          "0 2px 4px rgba(0, 0, 0, 0.1)",
                                        border: "1px solid #ddd",
                                        marginBottom: "12px",
                                      }}
                                    >
                                      <Typography
                                        variant="h6"
                                        style={{
                                          fontWeight: "bold",
                                          color: "#333",
                                          marginBottom: "10px",
                                        }}
                                      >
                                        {getStoreMap.get(
                                          row.minimumpriceDetails.storeId
                                        )}
                                      </Typography>

                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                          marginBottom: "8px",
                                        }}
                                      >
                                        <Typography
                                          variant="h6"
                                          style={{
                                            color:
                                              row.minimumpriceDetails.price > 0
                                                ? "#28a745"
                                                : "#e53e3e",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          {row.minimumpriceDetails.price
                                            ? `$${row.minimumpriceDetails.price}`
                                            : "N/A"}
                                        </Typography>

                                        <Typography
                                          variant="body2"
                                          style={{
                                            color: "#555",
                                            fontSize: "14px",
                                          }}
                                        >
                                          {row.productTotalUnit}{" "}
                                          {convertUnit(row.variantUnit)}
                                        </Typography>
                                      </div>

                                      {row.minimumpriceDetails.price > 0 && (
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            backgroundColor: "#f0f4f8",
                                            padding: "8px",
                                            borderRadius: "8px",
                                            marginTop: "8px",
                                            border: "1px solid #ccc",
                                          }}
                                        >
                                          <Typography
                                            variant="body1"
                                            style={{
                                              fontWeight: "bold",
                                              color: "#333",
                                            }}
                                          >
                                            Total Price:
                                          </Typography>

                                          <Typography
                                            variant="body1"
                                            style={{
                                              fontWeight: "bold",
                                              color: "#007bff",
                                            }}
                                          >
                                            $
                                            {row.minimumpriceDetails.price *
                                              row.productTotalUnit}
                                          </Typography>
                                        </div>
                                      )}
                                    </div>
                                  ) : (
                                    <Typography
                                      variant="body2"
                                      style={{ color: "#888" }}
                                    >
                                      No minimum price available
                                    </Typography>
                                  )}
                                </TableCell> */}
                                    </TableRow>
                                  );
                                }
                              )
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                      {selectedProduct && selectedProductData && (
                        <NewPopUpProduct
                          openModel={openDialog}
                          handleCloseDialog={handleCloseDialog}
                          // OrderlistEditProductId={selectedProduct}
                          data={selectedProductData}
                        />
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            {coursingToStatus && (
              <StatusPopup
                open={open}
                handleCloseDelete={handleCloseStatusPopup}
                onConfirm={async () => {
                  await handleChangeStatus(
                    String(orderListHistoryId).toString()
                  );
                }}
                title="Confirm Status Change"
                content={`Are you sure you want to change the status to "Manager Approval Pending"? 
              Once updated, this action cannot be undone. 
              Order ID: ${ReDateId}`}
              />
            )}

            <Dialog
              open={openOrderListDate}
              onClose={handleCloseDialogGenerate}
              sx={{ padding: 5, minWidth: 450 }}
            >
              <Grid
                className={
                  isMobileRes
                    ? classes.DialogMobileBgCard
                    : classes.DialogBgCard
                }
              >
                <form onSubmit={formik.handleSubmit}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                      alignContent={"center"}
                    >
                      <Typography className={classes.cardTitle}>
                        Confirm Action
                      </Typography>
                    </Grid>
                  </Grid>
                  <DialogContent>
                    <DialogContentText sx={{ pt: 3 }}>Status</DialogContentText>
                    <Grid container alignItems="center">
                      <Grid item lg={12} md={12} sm={12} xs={12} pt={1}>
                        <TextField
                          select
                          size="small"
                          className={classes.textField}
                          SelectProps={{
                            native: false,
                          }}
                          defaultValue=""
                          InputLabelProps={{ shrink: true }}
                          {...formik.getFieldProps("status")}
                        >
                          <MenuItem value="" disabled>
                            Select some option
                          </MenuItem>

                          {Object.entries(editPriceOrderListStatus).map(
                            ([key, value], index) => (
                              <MenuItem key={index} value={value}>
                                {convertStatus(key)}
                              </MenuItem>
                            )
                          )}
                        </TextField>
                      </Grid>
                    </Grid>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      variant="outlined"
                      startIcon={<CloseIcon />}
                      className={classes.addButton}
                      onClick={handleCloseDialogGenerate}
                    >
                      Cancel
                    </Button>
                    <Box m={0.5}></Box>

                    <Button
                      variant="contained"
                      startIcon={<CheckCircleOutlineIcon />}
                      className={classes.addButton}
                      onClick={() => formik.handleSubmit()}
                      disabled={!formValid || isLoading}
                    >
                      Confirm
                    </Button>
                  </DialogActions>
                </form>
              </Grid>
            </Dialog>
          </Grid>
        </Card>
      </Grid>

      <Grid item lg={4} md={6} sm={12} xs={12}>
        <Grid container spacing={1}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Card
              className={classes.orderListRightCard}
              sx={{ height: "100%" }}
            >
              <Grid container spacing={2} p={2}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid container justifyContent={"space-between"} spacing={1}>
                    <Grid
                      item
                      sx={{
                        display: "flex",
                        justifyContent: "flex-start",
                      }}
                    >
                      <Grid
                        container
                        spacing={1}
                        justifyContent="flex-start"
                        sx={{ display: "flex" }}
                      >
                        <Grid item>
                          <Typography className={classes.OLLeftHeading}>
                            {ReDateId}
                          </Typography>
                          <Typography className={classes.OLLeftHeading}>
                            {convertStatus(orderListStatus || "")}
                          </Typography>
                          {/* <Typography className={classes.rightORTypo}>
                            {"Created By : "}
                            {userMap.get(createBy) || ""}
                          </Typography>
                          {updatedBy && (
                            <Typography className={classes.rightORTypo}>
                              {"Updated By : "}
                              {userMap.get(updatedBy) || ""}
                            </Typography>
                          )} */}
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      sx={{
                        display: "flex",
                        justifyContent: "flex-start",
                      }}
                    >
                      <Grid
                        container
                        spacing={1}
                        justifyContent="flex-end"
                        sx={{ display: "flex" }}
                      >
                        <Grid item>
                          <Typography
                            textAlign={"right"}
                            className={classes.OLLeftHeading}
                          >
                            {restaurantMap.get(branchId) || ""}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid container spacing={3} mt={3}>
                    {Object.entries(groupedData).map(([storeId, orders]) => {
                      const storeName =
                        storeId === undefined || storeId === null
                          ? "Update Items Price to Supplier"
                          : getStoreMap.get(Number(storeId)) ||
                            "Supplier Not Found";

                      return (
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          key={storeId}
                        >
                          <Card className={classes.priceConfiremListCrd}>
                            <CardContent
                              sx={{
                                flex: 1,
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Typography
                                fontWeight="bold"
                                textAlign="center"
                                gutterBottom
                                className={classes.orderLsitHeadingTypoView}
                                style={{
                                  fontWeight: "bold",
                                  color: "#007bff",
                                }}
                              >
                                {storeName}
                              </Typography>

                              <List sx={{ flexGrow: 1 }}>
                                {orders.map((order, index) => (
                                  <React.Fragment key={order.id}>
                                    <ListItem
                                      sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        px: 2,
                                        py: 1,
                                      }}
                                    >
                                      {order.variantName.length > 20 ? (
                                        <Tooltip
                                          title={
                                            <>
                                              <Typography variant="body2">
                                                <strong>
                                                  {order.variantName}
                                                </strong>
                                              </Typography>
                                            </>
                                          }
                                          sx={{
                                            fontSize: "14px",
                                          }}
                                        >
                                          <Typography
                                            sx={{
                                              fontWeight: "bold",
                                              color: "#1a202c",
                                              flex: 1,
                                              textAlign: "left",
                                              cursor: "pointer",
                                            }}
                                          >
                                            <Link
                                              to={`/variant/view/${order.productId}`}
                                              className={
                                                classes.iconLinkPropNormal
                                              }
                                            >
                                              {`${order.variantName.slice(
                                                0,
                                                25
                                              )}...`}{" "}
                                            </Link>
                                          </Typography>
                                        </Tooltip>
                                      ) : (
                                        <Typography
                                          sx={{
                                            fontWeight: "bold",
                                            color: "#1a202c",
                                            flex: 1,
                                            textAlign: "left",
                                            cursor: "pointer",
                                          }}
                                        >
                                          <Link
                                            to={`/variant/view/${order.productId}`}
                                            className={
                                              classes.iconLinkPropNormal
                                            }
                                          >
                                            {`${order.variantName}`}{" "}
                                          </Link>
                                        </Typography>
                                      )}

                                      <Typography
                                        sx={{
                                          color: "#28a745",
                                          fontWeight: "bold",
                                          flex: 1,
                                          textAlign: "center",
                                        }}
                                      >
                                        {order.minimumpriceDetails?.price
                                          ? `$${order.minimumpriceDetails.price}`
                                          : "N/A"}
                                      </Typography>

                                      <Typography
                                        variant="body2"
                                        sx={{
                                          color: "#555",
                                          flex: 1,
                                          textAlign: "right",
                                        }}
                                      >
                                        {order.productTotalUnit}{" "}
                                        {convertUnit(order.variantUnit)}
                                      </Typography>
                                    </ListItem>

                                    {index !== orders.length - 1 && <Divider />}
                                  </React.Fragment>
                                ))}
                              </List>
                            </CardContent>
                          </Card>
                        </Grid>
                      );
                    })}
                  </Grid>
                </Grid>
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  p={1}
                  mt={5}
                  sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Button
                    variant="contained"
                    startIcon={
                      isLoading ? (
                        <CircularProgress
                          size={18}
                          className={classes.isLoading}
                        />
                      ) : (
                        <CheckCircleOutlineIcon />
                      )
                    }
                    className={classes.oLConformButton}
                    onClick={() => confirmFormik.handleSubmit()}
                    disabled={!confirmFormikValid}
                  >
                    Confirm Order List
                  </Button>
                </Grid>
                {/* <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  p={1}
                  sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Button
                    variant="outlined"
                    startIcon={<CloseIcon />}
                    className={classes.oLOCancelButton}
                    onClick={() => refetch()}
                  >
                    Refresh
                  </Button>
                </Grid> */}
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Index;
